<div class="celo-text-14 box">
  <div class="pic">
    <app-avatar
      [name]="name"
      [userId]="userId"
      [width]="150"
      [height]="150"
      [hasImage]="hasImage"
    >
    </app-avatar>
  </div>
  <div class="texts">
    <div class="item">
      <div class="name">
        {{ title }} {{ name }}
        <app-badge
          class="inline-block"
          [identityVerificationStatus]="identityVerificationStatus"
          [workspaces]="workspaces"
          [profession]="profession"
          [size]="28"
          [clickable]="false"
        ></app-badge>
      </div>
      @if (ownProfile) {
        <div>
          @if (profession && profession.verificationStatus) {
            <div class="profession">
              {{ profession.profession }}
              @if (profession.verificationStatus === "Pending") {
                <span> (Pending)</span>
              }
            </div>
          }
        </div>
      }
      @if (!ownProfile) {
        <div>
          @if (profession && profession.verificationStatus === "Verified") {
            <div class="profession">
              {{ profession.profession }}
            </div>
          }
        </div>
      }
    </div>
    <div class="badges-meaning celo-hoverable">
      @if (profession && profession.verificationStatus === "Verified") {
        <div class="item item-left-aligned">
          <div class="badge-title">
            <app-badge
              class="inline-block"
              [identityVerificationStatus]="'Verified'"
              [profession]="{ verificationStatus: 'Verified' }"
              [size]="20"
              [clickable]="false"
            ></app-badge>
            Verified profession
          </div>
          @if (profession.profession) {
            <div class="badge-subtitle item-left-aligned-subtitle">
              {{ profession.profession }}
            </div>
          }
        </div>
      }
      @if (identityVerificationStatus === "Verified") {
        <div class="item item-left-aligned">
          <div class="badge-title">
            <app-badge
              class="inline-block"
              [identityVerificationStatus]="'Verified'"
              [size]="20"
              [clickable]="false"
            ></app-badge>
            Verified identity
          </div>
          <div class="item-left-aligned-subtitle">
            <span class="badge-subtitle-lite">Verified as </span
            ><span class="badge-subtitle">{{ name_verified_as }}</span>
          </div>
        </div>
      }
      @if (isWorkspaceVerified) {
        <div class="item item-left-aligned">
          <div class="badge-title">
            <app-badge
              class="inline-block"
              [workspaces]="workspaces"
              [size]="20"
              [clickable]="false"
            ></app-badge>
            Verified workspaces
          </div>
          @for (
            workspace of verifiedWorkspaces;
            track workspace;
            let index = $index;
            let last = $last
          ) {
            <div class="badge-subtitle item-left-aligned-subtitle">
              @if (index < maxWorkspacesToShow) {
                <div>
                  {{ workspace.companyName }}
                </div>
              }
              @if (last && index >= maxWorkspacesToShow) {
                <div>
                  +{{ verifiedWorkspaces.length - maxWorkspacesToShow }} other
                  workspace{{
                    verifiedWorkspaces.length - maxWorkspacesToShow > 1
                      ? "s"
                      : ""
                  }}
                </div>
              }
            </div>
          }
        </div>
      }
      @if (!ownProfile && !hideUnverifiedStatus) {
        <div>
          @if (
            identityVerificationStatus !== "Verified" && !isWorkspaceVerified
          ) {
            <div class="item item-left-aligned">
              <div class="badge-title">
                <app-badge
                  class="inline-block"
                  [identityVerificationStatus]="'Unverified'"
                  [size]="20"
                  [clickable]="false"
                ></app-badge>
                Unverified user
              </div>
              <div class="item-left-aligned-subtitle subtext">
                Please use caution when contacting this user.
              </div>
            </div>
          }
        </div>
      }
      @if (ownProfile && !hideUnverifiedStatus) {
        <div>
          @if (identityVerificationStatus !== "Verified") {
            <div class="item">
              @if (identityVerificationStatus === "Pending") {
                <div>
                  <div class="badge-title">Identity verification pending</div>
                  <div class="subtext">
                    We're reviewing your request, you will become verified once
                    it has been approved by our team.
                  </div>
                  <div>&nbsp;</div>
                  <div class="subtext">
                    Contact
                    <a class="celo-link" href="mailto:support@celohealth.com"
                      >support&#64;celohealth.com</a
                    >
                    for help.
                  </div>
                </div>
              }
              @if (identityVerificationStatus === "Unverified") {
                <div>
                  <div class="badge-title">
                    <app-badge
                      class="inline-block"
                      [identityVerificationStatus]="'Unverified'"
                      [size]="20"
                      [clickable]="false"
                    ></app-badge>
                    Unverified user
                  </div>
                  <!-- <div class="subtext">You can verify your identity using <a class="celo-link" (click)="verifyIdentity()">the mobile app</a></div> -->
                  @if (isIdentityVerificationAvailable()) {
                    <app-verify-identity-info
                      [message]="'You can verify your identity using the mobile app'"
                    ></app-verify-identity-info>
                  } @else {
                    <div class="subtext">
                      {{ identityVerificationDisabledMessage }}
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
